/*
 * Built with Common Launchpad 2.0.3
 */

import axios from 'axios';
import * as CONST from '../utils/constants';

export default {
	postData(cb, { data, resource }) {
		axios.post(`${CONST.EnvironmentUrl}${resource}`, data)
        .then(response => response.data)
			.then(response => {
				cb(response);
			})
			.catch(err => cb(err.response));
	},
	getUserIp(cb, { data, resource }) {
		axios.get('https://api.hostip.info/get_json.php', {
			headers: {
				'Content-Type': 'application/json'
			}
		})
        .then(response => response.data)
			.then(response => {
				cb(response);
			})
			.catch(err => cb(err.response));
	}
};